<template>
  <div v-rect-loading="loading" class="offer-letter-container">
    <div class="container">
      <div class="download-btn">
        <i v-rect-loading="downloading" class="btn iconfont icona-ResumeDownload" :class="isPreview && 'preview'" @click="handleExportPDF"></i>
      </div>
      <div v-html="displayOfferLetterContent" class="offer-content"></div>
    </div>
    <div class="footer-btn">
      <div class="btn-container">
        <div class="btn-group">
          <el-button class="btn cancel" :disabled="isPreview" @click="handleReject">{{ $t(`${i18nPrefix}.btn.rejectOffer`) }}</el-button>
          <el-button class="btn save" :disabled="isPreview" @click="handleAccept">{{ $t('common.btn.accept') }}</el-button>
        </div>
      </div>
    </div>
    <DialogWrapper
      class="operate-dialog accept-offer-dialog"
      cancelBtnLabelI18nKey="common.btn.cancel"
      saveBtnLabelI18nKey="common.btn.submit"
      :titleI18nKey="`${i18nPrefix}.label.acceptOfferTitle`"
      :close-on-click-modal="false"
      :show.sync="showAcceptDialog"
      :loading="acceptLoading"
      @closed="handleCancelAccept"
      @save="handleSaveAccept"
    >
      <div class="accept-info">
        <WrappedForm
          ref="acceptForm"
          class="accept-field-info"
          label-width="220px"
          :model="acceptInfo"
          :formLines="acceptFormLines"
        >
          <template #signLabelSlot="{ line }">
            <div class="sign-label">{{ line.label }}</div>
          </template>
          <template #signSlot>
            <SignaturePad ref="signRef" width="100%"></SignaturePad>
            <div v-show="showSignTip" class="sign-tip">{{ $t('common.message.requiredFormField') }}</div>
          </template>
        </WrappedForm>
      </div>
    </DialogWrapper>
    <DialogWrapper
      class="operate-dialog reject-offer-dialog"
      cancelBtnLabelI18nKey="common.btn.cancel"
      saveBtnLabelI18nKey="common.btn.submit"
      :titleI18nKey="`${i18nPrefix}.label.rejectOfferTitle`"
      :close-on-click-modal="false"
      :show.sync="showRejectDialog"
      :loading="rejectLoading"
      @closed="handleCancelReject"
      @save="handleSaveReject"
    >
      <div class="reject-info">
        <WrappedForm
          ref="rejectForm"
          class="reject-field-info"
          label-width="220px"
          :model="rejectInfo"
          :formLines="rejectFormLines"
        >
        </WrappedForm>
      </div>
    </DialogWrapper>
    <DialogWrapper
      class="submit-accept-success-dialog"
      :show.sync="acceptSuccessDialog.show"
      :loading="acceptSuccessDialog.loading"
      :close-on-click-modal="false"
      :hideFooter="true"
    >
      <div class="accept-success-container">
        <i class="result-icon iconfont iconcompleted"></i>
        <span class="title-label">{{ $t(`${i18nPrefix}.label.acceptOfferSuccess`) }}</span>
        <el-button class="button view-offer-letter" type="primary" @click="handelToViewOfferLetter">{{ $t(`${i18nPrefix}.btn.viewAllOffer`) }}</el-button>
        <el-button class="button download-offer" @click="handleExportPDF(false)">
          <span class="label">{{ $t(`${i18nPrefix}.btn.downloadOfferLetter`) }}</span>
          <i class="icon el-icon-download"></i>
        </el-button>
      </div>
    </DialogWrapper>
    <DialogWrapper
      class="submit-reject-success-dialog"
      :show.sync="rejectSuccessDialog.show"
      :close-on-click-modal="false"
      :hideFooter="true"
    >
      <div class="reject-success-container">
        <i class="result-icon iconfont iconcompleted"></i>
        <span class="title-label">{{ $t(`${i18nPrefix}.label.rejectOfferSuccess`) }}</span>
        <el-button class="button view-offer-letter" type="primary" @click="handelToPersonalHome">{{ $t(`${i18nPrefix}.btn.toPersonalHome`) }}</el-button>
      </div>
    </DialogWrapper>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
import DialogWrapper from '@/components/dialog/dialogWrapper.vue'
import WrappedForm from '@/components/formEditor/wrappedForm.vue'
import SignaturePad from '@/components/common/sign/signaturePad.vue'
import { getFilePath, uploadBase64Src } from '@/utils/qiniu'
import { getI18nPropertyValue, addI18nProperty } from '@/i18n'
import { AsyncTask } from '@/utils/common'
import { OFFER_LETTER_TEMPLATE_FIELD_TYPE } from '@/constant/company'
import mixin from '../mixin'

export default {
  mixins: [mixin],
  components: {
    DialogWrapper,
    WrappedForm,
    SignaturePad
  },
  props: {
    isPreview: {
      type: Boolean,
      default: false
    },
    previewOfferLetterInfo: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      OFFER_LETTER_TEMPLATE_FIELD_TYPE,
      i18nPrefix: 'personal.offerLetter',
      loading: false,
      downloading: false,
      showAcceptDialog: false,
      acceptLoading: false,
      showSignTip: false,
      showRejectDialog: false,
      rejectLoading: false,
      templateFieldList: [],
      acceptInfo: {},
      rejectCaseList: [],
      rejectInfo: {
        rejectCase: null,
        caseComment: null
      },
      inviteRecordInfo: {
        offer_letter_content: null
      },
      acceptSuccessDialog: {
        show: false,
        loading: false
      },
      rejectSuccessDialog: {
        show: false
      }
    }
  },
  computed: {
    jobId () {
      return this.$route.query.job_id
    },
    candidateId () {
      return this.$route.query.candidate_id
    },
    inviteId () {
      return this.$route.query.invite_id
    },
    companyId () {
      return this.$route.query.company_id
    },
    displayOfferLetterContent () {
      if (this.inviteRecordInfo.offer_letter_content) {
        return this.formatContent(this.inviteRecordInfo.offer_letter_content, this.acceptInfo)
      }
      return ''
    },
    templateContentFields () {
      const content = this.inviteRecordInfo.offer_letter_content
      if (!content) {
        return []
      }
      const allKeys = this.getTemplateAllPlaceholder(content)
      const templateFields = _.chain(this.templateFieldList).filter(item => _.includes(allKeys, item.key)).map(item => {
        item.order = _.findIndex(allKeys, key => key === item.key)
        return item
      }).orderBy('order').value()
      return templateFields
    },
    acceptFormLines () {
      const lines = {}
      const content = this.inviteRecordInfo.offer_letter_content
      if (!content) {
        return lines
      }
      const templateFieldList = _.filter(this.templateContentFields, { type: 'CANDIDATE' })
      _.forEach(templateFieldList, item => {
        const key = item.key
        const label = getI18nPropertyValue(item, 'name_cn', 'name_en')
        const lineProps = { clearable: true }
        const line = {
          label: label,
          elType: 'el-input',
          props: lineProps,
          rules: [{ required: true, message: this.$t('common.message.requiredFormField'), trigger: 'blur' }]
        }
        const valueType = item.value_type
        if (valueType === OFFER_LETTER_TEMPLATE_FIELD_TYPE.SELECT) {
          line.elType = 'el-select'
          lineProps.filterable = true
          lineProps.multiple = true
          line.option = {
            data: item.option_list,
            valueKey: 'id',
            labelKey: 'i18nName'
          }
        } else if (valueType === OFFER_LETTER_TEMPLATE_FIELD_TYPE.SINGLE) {
          line.elType = 'el-select'
          lineProps.filterable = true
          lineProps.multiple = false
          line.option = {
            data: item.option_list,
            valueKey: 'id',
            labelKey: 'i18nName'
          }
        } else if (valueType === OFFER_LETTER_TEMPLATE_FIELD_TYPE.TEXT) {

        } else if (valueType === OFFER_LETTER_TEMPLATE_FIELD_TYPE.TEXTAREA) {
          lineProps.type = 'textarea'
          lineProps.autosize = { minRows: 3 }
        } else if (valueType === OFFER_LETTER_TEMPLATE_FIELD_TYPE.DATE) {
          line.elType = 'el-date-picker'
        } else if (valueType === OFFER_LETTER_TEMPLATE_FIELD_TYPE.SIGN) {
          line.labelSlot = 'signLabelSlot'
          line.contentSlot = 'signSlot'
          line.rules = []
        }
        lines[key] = line
      })
      return lines
    },
    rejectFormLines () {
      const lines = {
        rejectCase: {
          elType: 'el-select',
          label: this.$t(`${this.i18nPrefix}.label.rejectCase`),
          option: {
            data: this.rejectCaseList,
            valueKey: 'id',
            labelKey: 'i18nName'
          },
          rules: [{ required: true, message: this.$t('common.message.requiredFormField'), trigger: 'blur' }]
        },
        caseComment: {
          elType: 'el-input',
          label: this.$t(`${this.i18nPrefix}.label.rejectCaseComment`)
        }
      }
      return lines
    }
  },
  created () {
    this.initPage()
  },
  mounted () {
    this.resetAcceptInfo()
  },
  methods: {
    ...mapActions('candidateStatus', ['getStatusChangeReasonList']),
    ...mapActions('application', [
      'createExportCandidateOfferLetterInfoTask',
      'getExportCandidateOfferLetterTaskStatus'
    ]),
    ...mapActions('offerLetter', ['getOfferLetterInviteRecordInfoById', 'saveCandidateOfferLetterOperate', 'getOfferLetterTemplateFieldList']),
    async initPage () {
      await this.loadTemplateFiledList()
      if (this.isPreview) {
        this.inviteRecordInfo = this.previewOfferLetterInfo
        this.resetAcceptInfo()
      } else {
        this.loadInviteOfferLetterInfo()
        this.loadRejectOfferCaseList()
      }
    },
    async loadTemplateFiledList () {
      const resp = await this.getOfferLetterTemplateFieldList({ company_id: this.companyId })
      if (resp) {
        _.forEach(resp, item => {
          _.forEach(item.option_list, option => {
            addI18nProperty(option, 'i18nName', 'name_cn', 'name_en')
          })
        })
        this.allTemplateFiledList = resp
        this.templateFieldList = resp
      }
    },
    async loadInviteOfferLetterInfo () {
      this.loading = true
      try {
        const params = {
          invite_id: this.inviteId,
          job_id: this.jobId
        }
        const resp = await this.getOfferLetterInviteRecordInfoById(params)
        if (resp) {
          this.inviteRecordInfo = resp
          this.resetAcceptInfo()
        }
      } finally {
        this.loading = false
      }
    },
    resetAcceptInfo () {
      _.forEach(this.templateContentFields, field => {
        if (!_.has(this.acceptInfo, field.key)) {
          this.$set(this.acceptInfo, field.key, null)
        }
      })
    },
    async loadRejectOfferCaseList () {
      const resp = await this.getStatusChangeReasonList({
        status_key: 'Offer Rejected',
        company_id: this.companyId
      })
      if (resp) {
        this.rejectCaseList = _.map(resp, item => addI18nProperty(item, 'i18nName', 'name_cn', 'name_en'))
      }
    },
    handleAccept () {
      this.showAcceptDialog = true
    },
    handleReject () {
      this.showRejectDialog = true
    },
    handleCancelAccept () {
      this.handleClearSign()
      this.showAcceptDialog = false
    },
    handleClearSign () {
      if (this.$refs.signRef && !this.$refs.signRef.isEmpty()) {
        this.$refs.signRef.clear()
      }
    },
    async uploadSign (base64Src) {
      const fileName = `${this.candidateId}_${this.jobId}_${new Date().valueOf()}_sign.png`
      const fileKey = `offerLetter/candidateSign/${this.candidateId}/${this.jobId}/${fileName}`
      const resp = await uploadBase64Src(fileKey, base64Src)
      if (resp) {
        this.fileKey = resp.key
        const filePath = getFilePath(this.fileKey)
        return filePath
      }
    },
    async handleSaveAccept () {
      if (!await this.$refs.acceptForm.submit()) {
        return
      }
      if (this.$refs.signRef && this.$refs.signRef.isEmpty()) {
        this.showSignTip = true
        return
      }

      this.acceptLoading = true
      try {
        if (this.$refs.signRef) {
          const signData = await this.$refs.signRef.toDataURL()
          this.acceptInfo.signature = await this.uploadSign(signData)
        } else {
          this.acceptInfo.signature = null
        }
        const acceptInfo = this.formatOfferLetterInfo(this.acceptInfo)
        this.inviteRecordInfo.offer_letter_content = this.formatContent(this.inviteRecordInfo.offer_letter_content, this.acceptInfo)
        const info = {
          invite_id: this.inviteId,
          candidate_id: this.candidateId,
          job_id: this.jobId,
          status: 1,
          accept_info: acceptInfo,
          offer_letter_content: this.inviteRecordInfo.offer_letter_content
        }
        await this.saveCandidateOfferLetterOperate(info)
        this.acceptSuccessDialog.show = true
      } finally {
        this.acceptLoading = false
        this.showAcceptDialog = false
      }
    },
    handleCancelReject () {
      this.showRejectDialog = false
    },
    async handleSaveReject () {
      if (!await this.$refs.rejectForm.submit()) {
        return
      }
      this.rejectLoading = true
      try {
        const info = {
          invite_id: this.inviteId,
          candidate_id: this.candidateId,
          job_id: this.jobId,
          status: 2,
          reject_case_id: this.rejectInfo.rejectCase,
          reject_comment: this.rejectInfo.caseComment
        }
        await this.saveCandidateOfferLetterOperate(info)
        this.rejectSuccessDialog.show = true
      } finally {
        this.rejectLoading = false
        this.showRejectDialog = false
      }
    },
    handelToPersonalHome () {
      this.$router.push({ path: '/recruiting/personal/home', query: { company_id: this.companyId } })
    },
    handleExportPDF (defaultLoading = true) {
      if (this.isPreview) {
        return
      }
      if (defaultLoading) {
        this.downloading = true
      } else {
        this.acceptSuccessDialog.loading = true
      }
      const exportOfferLetterPdfStatus = {
        finished: false,
        task: null
      }
      exportOfferLetterPdfStatus.finished = false
      exportOfferLetterPdfStatus.task = new AsyncTask(() => this.createExportCandidateOfferLetterInfoTask({
        candidate_id: this.candidateId,
        job_id: this.jobId
      }), (taskId) => this.getExportCandidateOfferLetterTaskStatus({
        task_id: taskId
      }), (taskId) => {
        window.location.href = this.$DjangoBaseUrl(`/django_rest/company/job/application/export/offer-letter/?task_id=${taskId}&download=1`)
        exportOfferLetterPdfStatus.finished = false
        exportOfferLetterPdfStatus.task = null
        this.downloading = false
        this.acceptSuccessDialog.loading = false
      })
    },
    handelToViewOfferLetter () {
      this.$router.replace({ path: `/recruiting/personal/offer-letter/${this.inviteId}/detail`, query: { company_id: this.companyId } })
    }
  }
}
</script>

<style lang="scss" scoped>
.offer-letter-container {
  .container {
    width: 822px;
    margin: 30px auto 0 auto;

    .offer-content {
      padding: 26px 120px 96px 120px;
      border-top: 0;
      border-left: 1px solid #c0c4cc;
      border-right: 1px solid #c0c4cc;
    }

    .download-btn {
      padding: 50px 120px 0 120px;
      align-items: center;
      display: flex;
      justify-content: flex-end;
      border: 1px solid #c0c4cc;
      border-bottom: 0;
      .btn {
        font-size: 20px;
        color: #0096cc;
        cursor: pointer;
      }

      ::v-deep {
        .el-loading-spinner {
          margin-top: -12px;

          .loading-spinner {
            .spinner {
              width: 20px;
              height: 20px;

              >div {
                width: 3px;
              }
            }
          }
        }
      }
      .preview {
        cursor: not-allowed;
      }
    }

  }

  .footer-btn {
    border-top: 1px solid #c0c4cc;
    padding: 20px 0;
    background-color: #fff;
    position: sticky;
    bottom: 0;
    .btn-container {
      width: 822px;
      margin: auto;
      display: flex;
      align-items: center;
      justify-content: flex-end;

      .btn-group {
        .btn {
          padding: 6px 28px;
          border-radius: 2px;
          line-height: 22px;
          font-size: 14px;
          font-weight: 500;
          color: #0096cc;
        }
        .save {
          margin-left: 24px;
          margin-right: 0;
          background: #0096cc;
          border-color: #0096cc;
          color: #fff;
        }
      }
    }
  }

  .operate-dialog {
  }

  .accept-offer-dialog {
    .accept-info {
      .accept-field-info {
        .sign-label {
          position: relative;
          &::after {
            content: "*";
            margin: 5px 0 0 3px;
            color: #f56c6c;
            line-height: 1;
            position: absolute;
          }
        }
        .sign-tip {
          color: #F56C6C;
          font-size: 12px;
          line-height: 1;
          padding-top: 4px;
        }
      }
    }
  }

  .submit-accept-success-dialog {
    .accept-success-container {
      display: flex;
      width: 100%;
      flex-direction: column;
      align-items: center;

      .result-icon {
        font-size: 50px;
        color: #10aa64;
        margin-right: 10px;
      }

      .title-label {
        margin-top: 16px;
        font-size: 20px;
        font-weight: 500;
        color: #303133;
        line-height: 30px;
        word-break: break-word;
        white-space: normal;
        text-align: center;
      }
      .title-tips {
        margin-top: 10px;
        height: 22px;
        font-size: 12px;
        font-weight: 400;
        color: #606266;
        line-height: 22px;
      }

      .button {
        width: 260px;
        height: 40px;
        margin: 0;
        border-radius: 2px;
      }

      .view-offer-letter {
        margin-top: 26px;
      }

      .download-offer {
        margin-top: 12px;
        margin-bottom: 6px;
        color: #0096cc;

        &:hover {
          border: 1px solid #0096cc;
        }

        .icon {
          margin-left: 4px;
        }
      }
    }
  }

  .submit-reject-success-dialog {
    .reject-success-container {
      display: flex;
      width: 100%;
      flex-direction: column;
      align-items: center;

      .result-icon {
        font-size: 50px;
        color: #10aa64;
        margin-right: 10px;
      }

      .title-label {
        margin-top: 16px;
        font-size: 20px;
        font-weight: 500;
        color: #303133;
        line-height: 30px;
        word-break: break-word;
        white-space: normal;
        text-align: center;
      }
      .title-tips {
        margin-top: 10px;
        height: 22px;
        font-size: 12px;
        font-weight: 400;
        color: #606266;
        line-height: 22px;
      }

      .button {
        width: 260px;
        height: 40px;
        margin: 0;
        border-radius: 2px;
      }

      .view-offer-letter {
        margin-top: 26px;
      }
    }
  }
}
</style>
